export default __webpack_public_path__ + "static/media/goldenrod.c067d22e.jpg";